import { DepartmentEntityModel } from "src/store/models/entity/department/entity";
import { DepartmentHelperModel } from "src/store/models/entity/department/helper";

export const departmentModels = {
  entity: DepartmentEntityModel,
  helper: DepartmentHelperModel,
};
